const categories = ["teplota","pocitová teplota", "oblačnost", "vítr"];

export default categories;
